import { render, staticRenderFns } from "./emissionsProduct.vue?vue&type=template&id=1339c2df"
import script from "./emissionsProduct.vue?vue&type=script&lang=js"
export * from "./emissionsProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1339c2df')) {
      api.createRecord('1339c2df', component.options)
    } else {
      api.reload('1339c2df', component.options)
    }
    module.hot.accept("./emissionsProduct.vue?vue&type=template&id=1339c2df", function () {
      api.rerender('1339c2df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/emissionsProduct.vue"
export default component.exports